import http from "../../services/httpService";
import { injectHtml } from "../../utils/htmlUtil";
import { openDialog, dialogModel } from "../common/dialog";
import { error, isEmpty, initToggleIconRotate, rotateElement } from "../common/global";
import { catchError } from "../../utils/errorUtil";
import { initBasketEvents, addToBasketCustomerAlsoBought } from "../ui/basket";

const props = {
    productPageCoreMarker: '#m-product-page-core',


    productDynamicContentMarker: '#m-product-page-dynamic-content',
    productDynamicContentWrapper: '#product-dynamic-content',
    productPurchaseDetailsWrapper: '#product-purchase-details-wrapper',
    //COLLAPSIBLE SECTIONS
    collapsibleSectionWrapper: '.collapsible-section-wrapper',
    collapsibleSectionHeader: '.collapsible-section-header',
    collapsibleSectionContent: '.collapsible-section-content',

    //SPECIFICATIONS
    showSecondarySpecificationsWrapper: '#show-secondary-specifications-wrapper',
    showSecondarySpecifications: '#show-secondary-specifications',
    secondarySpecificationsWrapper: '#secondary-specifications-wrapper',

    //BUNDLE PRODUCT PROPERTIES
    bundleComponentOption: '.bundle-component-option',
    bundleNoneSelectedOption: '.bundle-none-selected',
    bundleNoneSelectedMessage: '.bundle-none-selected-message',
    productDifferentialOption: '.product-option',
    selectedOptionClass: 'selected-option',
    productFullPrice: '.p-full-price-value',
    productSalePrice: '.p-sale-price-value',
    primaryProductVariant: '#ppv'

    //PRODUCT WITH VARIANTS

};


export function initProductPage() {

    if ($(props.productPageCoreMarker).length) {

        initProductPageCore();
        initBundleComponentOptionEvents();
        initProductVariantOptionEvents();
    }

    if ($(props.productDynamicContentMarker).length) {
        loadDynamicContent();
    }
}

//START - PRODUCT PAGE - CORE
async function initProductPageCore() {

    var mySwiper = new Swiper('.swiper-container', {
        speed: 400,
        spaceBetween: 100,
        allowTouchMove: false, // By default this is enabled, however it can interfere with the play button for slides with a video.
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    initCarouselItemVideos();
}

async function initBundleComponentOptionEvents() {

    $(props.bundleComponentOption + ":not('.oos')").off('click').on('click', function () {

        var parentWrapper = $(this).closest('.bundle-component-wrapper');

        if ($(this).hasClass(props.selectedOptionClass)) {

            $(this).removeClass(props.selectedOptionClass);

            //recalc displayed page prices
            recalculateLinkedProductDisplayedPrices();

            parentWrapper.find(props.bundleNoneSelectedOption).click();
        }
        else {

            parentWrapper.find(props.bundleComponentOption).removeClass(props.selectedOptionClass);

            $(this).addClass(props.selectedOptionClass);

            //recalc displayed page prices
            recalculateLinkedProductDisplayedPrices();

            if ($(props.bundleNoneSelectedMessage).length) {

                parentWrapper.find(props.bundleNoneSelectedOption).removeClass(props.selectedOptionClass);

                parentWrapper.find(props.bundleNoneSelectedMessage).hide(500);
            }
        }

    });

    $(props.bundleNoneSelectedOption).off('click').on('click', function () {

        var parentWrapper = $(this).closest('.bundle-component-wrapper');

        parentWrapper.find(props.bundleComponentOption).removeClass(props.selectedOptionClass);

        $(this).addClass(props.selectedOptionClass);

        //recalc displayed page prices
        recalculateLinkedProductDisplayedPrices();

        if (parentWrapper.find(props.bundleNoneSelectedMessage).length) {

            parentWrapper.find(props.bundleNoneSelectedMessage).show(500);
        }
    });
}


async function initProductVariantOptionEvents() {

    $(props.productDifferentialOption + ":not('.selected-option'):not('.oos')").off('click').on('click', function () {

        productDifferentialOptionSelected($(this));
    });
}

async function recalculateLinkedProductDisplayedPrices() {

    //NOTE: this should only be called by events that occur on a product page configured for linked product items
    //this is dependent upon 2 factors:

    // - primary product variant price
    // - any selected linked products

    const ppvEntity = $(props.primaryProductVariant)
    const primaryProductFullPriceValue = parseFloat((ppvEntity).data('fp'));
    const primaryProductSalePriceValue = parseFloat((ppvEntity).data('sp'));

    let newFullPrice = primaryProductFullPriceValue;

    //previous calculations assumed all products would either be full price or on sale. of course, you could actually have a mix of the two.
    //as such newActualPrice will pull the actual prices of the relative bundle components (fp or sp, if set)
    let newActualPrice = primaryProductFullPriceValue;

    if (!isNaN(primaryProductSalePriceValue)) {
        newActualPrice = primaryProductSalePriceValue;
    }

    const selectedLinkedProductItems = $(props.bundleComponentOption + '.' + props.selectedOptionClass);

    selectedLinkedProductItems.each(function (i, obj) {

        const slpFp = parseFloat($(this).data('fp'));
        const slpSp = parseFloat($(this).data('sp'));

        //always add item full price to the full price running total
        newFullPrice = newFullPrice + slpFp;

        if (!isNaN(slpSp)) {

            //sale price present for this item. add sale price to running total
            newActualPrice = newActualPrice + slpSp;
        } else {

            newActualPrice = newActualPrice + slpFp;
        }
    });

    $(props.productFullPrice).html(newFullPrice.toFixed(2));

    if (!isNaN(newActualPrice) && newActualPrice < newFullPrice) {
        paypal.Messages({
            amount: newActualPrice,
            pageType: 'product-details',
            style: {
                layout: 'text',
                logo: {
                    type: 'primary',
                    position: 'top'
                }
            }
        }).render('.pp-message');
        $(props.productSalePrice).html(newActualPrice.toFixed(2));

        $('#sale-price-wrapper').show();
        $('#full-price-wrapper').hide();
    }
    else {
        paypal.Messages({
            amount: newFullPrice,
            pageType: 'product-details',
            style: {
                layout: 'text',
                logo: {
                    type: 'primary',
                    position: 'top'
                }
            }
        }).render('.pp-message');
        $('#sale-price-wrapper').hide();
        $('#full-price-wrapper').show();
    }
}


async function productDifferentialOptionSelected(selectedDifferentialOptionElement) {

    //remove 'selected-option' from any items in the same differential
    var differentialParent = selectedDifferentialOptionElement.closest('.product-differential-wrapper');
    differentialParent.find(props.productDifferentialOption).removeClass(props.selectedOptionClass);

    //then get the details of any other selected differential options
    var currentlySelectedDifferentialOptions = [];

    $(props.productDifferentialOption + '.' + props.selectedOptionClass).each(function () {
        currentlySelectedDifferentialOptions.push($(this).data('attribute-id'));
    });

    //call service to return new html
    const productId = $(props.productDynamicContentWrapper).data('pid');
    const selectedProductAttributeValueId = selectedDifferentialOptionElement.data('attribute-id');


    const data = {
        productId: productId,
        selectedProductAttributeValueId: selectedProductAttributeValueId,
        currentlySelectedProductAttributes: currentlySelectedDifferentialOptions
    };

    const result = await differentialOptionSelectedService(data);

    await injectHtml(props.productPurchaseDetailsWrapper, result);

    setTimeout(function () {
        initProductVariantOptionEvents();
        initBasketEvents();
    }, 100);

    //rebind events
}


//END - PRODUCT PAGE - CORE


//START - PRODUCT PAGE - DYNAMIC CONTENT
async function loadDynamicContent() {

    const productId = $(props.productDynamicContentWrapper).data('pid');

    const data = { id: productId };
    const result = await getProductDynamicContent(data);

    await injectHtml(props.productDynamicContentWrapper, result);

    setTimeout(function () {
        initDynamicContentEvents();
    }, 100);
}

async function initDynamicContentEvents() {

    $(props.collapsibleSectionHeader).off('click').on('click', function () {

        let rotatableIcon = $(this);

        if (!rotatableIcon.hasClass('rotatable')) {
            rotatableIcon = $(this).find('.rotatable');
        }

        rotateElement(rotatableIcon, 45);

        const section_parent = $(this).closest(props.collapsibleSectionWrapper);

        const section_body = section_parent.find(props.collapsibleSectionContent);

        if (section_body.is(':visible')) {

            //body is currently displayed. hide it
            section_body.hide(500);

        } else {

            //body is currently hidden. display it
            section_body.show(500);
        }
    });
    
    $(props.showSecondarySpecifications).off('click').on('click', function () {

        $(props.showSecondarySpecificationsWrapper).hide(500, function () {

            $(props.secondarySpecificationsWrapper).show(500);
        });
    });

    addToBasketCustomerAlsoBought();
}

async function getProductDynamicContent(data) {

    //no TRY CATCH as handled by parent
    //returns 'dynamic product content' as html
    const response = await http.get('/product/dynamiccontent', data);

    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}

//END - PRODUCT PAGE - DYNAMIC CONTENT

//PRODPU WITH VARIANTS - DIFFERENTIAL OPTION SELECTED

async function differentialOptionSelectedService(data) {

    const response = await http.post('/product/differentialoptionselected', data);

    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}

function initCarouselItemVideos() {
    const videoModal = $(".product-video-modal");
    const videoIframe = $(".product-video-iframe");

    $(".show-product-video").click(function() {
        let videoUrl = $(this).data("url");
        const searchParams = new URLSearchParams(videoUrl.replace("https://www.youtube.com/watch", ""));

        if (searchParams.has("v"))
            videoUrl = "https://www.youtube.com/embed/" + searchParams.get("v");

        videoIframe.attr("src", videoUrl);
        videoModal.fadeIn();
    });

    $(".product-video-modal-bg, .product-video-modal-close").click(function () {
        closeProductVideoModal();
    });
}

function closeProductVideoModal() {
    const videoModal = $(".product-video-modal");
    const videoIframe = $(".product-video-iframe");

    videoModal.fadeOut();
    videoIframe.attr("src", "");
}